"use client";
import { Api } from "@/Apis";
import { Helper } from "@/Helpers";
import { selectProps } from "@/Helpers/Constants";
import { Select, SelectProps } from "antd";
import { FC, useEffect, useState } from "react";

export interface LandingCenterBranchSelectProps extends SelectProps {
  HasOnlineOrder?: boolean;

  autoSelectFirstOption?: boolean;
}

const LandingCenterBranchSelect: FC<LandingCenterBranchSelectProps> = ({
  autoSelectFirstOption,
  HasOnlineOrder,
  ...props
}) => {
  useEffect(() => {
    getOptions();
  }, [HasOnlineOrder]);

  const [options, setOptions] = useState<any[]>();
  const [loading, setLoading] = useState(true);
  const getOptions = async () => {
    setLoading(true);
    const { Result } = await Api.LandingSelect.getCenterBranches({
      HasOnlineOrder,
    });
    const options = Helper.arrayToOptions(Result);
    setOptions(options);
    if (autoSelectFirstOption && options.length > 0)
      props.onChange?.(options[0].value, options[0]);
    setLoading(false);
  };
  return (
    <Select
      options={options}
      loading={loading}
      {...selectProps}
      {...(props as any)}
      value={
        options?.map((p) => p.value).includes(props.value)
          ? props.value
          : undefined
      }
    />
  );
};

export default LandingCenterBranchSelect;
